import { computed, type MaybeRefOrGetter, toValue } from 'vue';
import { useTourSeoInfo } from '@/entities/region/api/useTourSeoInfo.ts';

/**
 * SEO-данные листинга туров по городу с выбранным тэгом.
 *
 * Дёргает `/api/seo/v2/citytag_tours/?ids={citySlug}__{tag}` через generic `getTourSeoById`.
 *
 * @param tagId составной id вида `{citySlug}__{tag}`
 * @param enabled включена ли загрузка
 * @returns реактивные SEO-данные и флаги загрузки
 */
export const useTourCityTagSeoInfo = (
  citySlug: MaybeRefOrGetter<string>,
  tagId: MaybeRefOrGetter<string>,
  enabled: MaybeRefOrGetter<boolean>,
) => {
  const compositeId = computed(() => `${toValue(citySlug)}__${toValue(tagId)}`);

  const { tourSeoData, isSuccess, isFetching } = useTourSeoInfo('citytag_tours', compositeId, enabled);

  return {
    cityTagSeoData: tourSeoData,
    isSuccess,
    isFetching,
  };
};
